import { render, staticRenderFns } from "./FeatureValues.vue?vue&type=template&id=187eb8b5&scoped=true&"
import script from "./FeatureValues.vue?vue&type=script&lang=js&"
export * from "./FeatureValues.vue?vue&type=script&lang=js&"
import style0 from "./FeatureValues.vue?vue&type=style&index=0&id=187eb8b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187eb8b5",
  null
  
)

export default component.exports